import React from "react"
import PropTypes from "prop-types"
import { Flex, Modal } from "antd"
import { useTranslation } from "react-i18next"
import successCheck from "assets/icons/booking-success-check.svg"
import successClose from "assets/icons/booking-success-close.svg"
import styles from "./WidgetCheckout.module.css"

// Shown once the booking (or the order of several) is paid: its ID above the title, and as children
// the next steps (waiver, questionnaire) — for several, a row per booking. 40px from the screen's
// sides on a tablet (Figma 6058:146238), 16px on a phone.
const BookingSuccessModal = ({ idText, isOpen, onClose, children }) => {
  const { t } = useTranslation()
  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={1016}
      className={styles.successModal}
      maskClosable={false}
      closeIcon={<img src={successClose} alt="" width={24} height={24} />}
    >
      <Flex vertical align="center" gap={24} className={styles.successBody}>
        <span className={styles.successIcon}>
          <img src={successCheck} alt="" />
        </span>
        <Flex vertical align="center" gap={12}>
          {idText && <span className={styles.successId}>{idText}</span>}
          <h2 className={styles.successTitle}>{t("booking_widget.success.title")}</h2>
          <span className={styles.successText}>{t("booking_widget.success.text")}</span>
        </Flex>
        {children}
      </Flex>
    </Modal>
  )
}

BookingSuccessModal.propTypes = {
  idText: PropTypes.string,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node
}

BookingSuccessModal.defaultProps = {
  idText: null,
  isOpen: false,
  children: null
}

export default BookingSuccessModal
